// extracted by mini-css-extract-plugin
module.exports = {"article":"Article_article__4ud3F","box":"Article_box__4KuHF","button":"Article_button__iq42K"};